export default "__VITE_ASSET__X8FpF2HW__"